<template>
  <div class="content-box" :style="{ padding: pd10 }">
    <recom></recom>
  </div>
</template>
<script>
import { IMSDK as PlatformIMSDK } from '@zjw-jszn/platform-imsdk'
import { IMSDK as StoreIMSDK } from '@zjw-jszn/store-imsdk'
import { API_BASE, API_HOST, WS_ORIGIN } from '@/config/api'
import recom from './recom.vue'

export default {
  name: 'contentBox',
  components: { recom },
  data() {
    return {
      pd10: '10px',
    }
  },
  created() {
    this.initIM()
  },
  watch: {
    $route: {
      handler(to) {
        this.pd10 = to.path === '/haowu/manager/overview' ? '0' : '10px'
      },
      immediate: true,
    },
  },
  methods: {
    async initIM() {
      const page = sessionStorage.getItem('loginPage')
      const userinfo = JSON.parse(sessionStorage.getItem('userinfo') || '{}')
      if (!userinfo.mobile) return

      const baseConfig = {
        phone: userinfo.mobile,
        avatar: userinfo.avatar_url ?? `${API_HOST}/assets/logo-DS3pmhuS.png`,
        username: userinfo.realname,
        api: {
          baseURL: API_BASE,
          resourceBaseURL: API_BASE,
          uploadURL: `${API_BASE}/system/uploadImage`,
          signKey: 'Z0XYfLbnDpuVqk41',
          suffix: '43cf28',
          groupId: 6,
          siteId: 6,
          defaultSignKey: 'Z0XYfLbnDpuVqk41',
        },
      }

      if (page === '/login') {
        // 暂时注释，不启用 getAuthorization 接口
        /* await PlatformIMSDK.init({
          ...baseConfig,
          ws: {
            url: WS_ORIGIN,
            wsController: 'Site',
            wsPlatform: 'site',
          },
        }) */
      } else {
        await StoreIMSDK.init({
          ...baseConfig,
          api: {
            ...baseConfig.api,
            uploadFileURL: `${API_BASE}/system/uploadFile`,
          },
          ws: {
            url: WS_ORIGIN,
            wsController: 'Manager',
            wsPlatform: 'manager',
          },
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.content-box {
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
}
</style>
